// extracted by mini-css-extract-plugin
module.exports = {"outer":"overlayLoaderV2_outer__30rtP","inner":"overlayLoaderV2_inner__22kUf","title":"overlayLoaderV2_title__2tgxY"};